export default {
  traceability: {
    traceability: "traçabilité",
    traceabilityManagement: "Gestion de la traçabilité",
    coffeeTraceabilityMngmnt: "Gestion de la traçabilité du café",
    traceabilityPage: "Page de traçabilité",
    labelDesigner: "Concepteur d'étiquettes",
    additionalInformation: "Informations supplémentaires",
    coffeeInformation: "Informations sur le café",
    info1:
      "Fournissez des informations sur les logos supplémentaires de votre produit. Ces informations seront disponibles au public sur la page de traçabilité du café.",
    cropsinfo1:
      "Fournissez des informations sur les logos supplémentaires de votre produit. Ces informations seront disponibles au public sur la page de traçabilité.",
    addSlogan: "Ajouter un slogan",
    sloganToolTip:
      "Ajoutez un slogan à votre produit. Cette information sera disponible au public sur la page de traçabilité.",
    additionalLogos: "Logos supplémentaires",
    title: "Titre",
    sloganHint: "Le slogan doit comporter 60 caractères maximum",
    sloganLengthError: "Longueur du slogan trop longue",
    description: "Description",
    mapLink: "Lien vers la carte",
    mapLinkTooltip: "Fournissez un lien vers la carte de votre produit.",
    originCountryTitle: "Nom du pays d'origine",
    enterOriginCountryTitle: "Entrez le nom du pays d'origine",
    enterCountryDescription:
      "Fournissez des informations intéressantes sur le pays d'origine",
    originatingCountryTooltip:
      "Fournissez des informations sur le pays d'origine de votre produit.",
    corporativeTitle: "Nom de la coopérative",
    enterCorporativeTitle: "Entrez le nom de la coopérative",
    introDescription:
      "Les détails supplémentaires peuvent inclure des informations sur la production, les intermédiaires de la chaîne d'approvisionnement, les détails du transport, les conditions de stockage, le traitement, la conformité réglementaire, etc.",
    corporativeTooltip: "Fournissez des informations sur la coopérative.",
    coperativeDescriptionTooltip:
      "Fournissez des informations sur la coopérative avec laquelle votre ferme est associée.",
    websiteLink: "Lien du site Web",
    addMedia: "Ajouter des médias",
    uploadImageVideo: "Télécharger une image/vidéo",
    uploadImage: "Télécharger une image",
    origin: "Origine",
    originationCountry: "Pays d'origine",
    info2:
      "Fournissez des informations sur le pays d'origine de votre produit. Ces informations seront disponibles au public sur la page de traçabilité du café.",
    cropsinfo2:
      "Fournissez des informations sur le pays d'origine de votre produit. Ces informations seront disponibles au public sur la page de traçabilité.",
    countryImage: "Image du pays",
    traceabilityImage: "Image de traçabilité",
    institutionalInfo: "Informations sur la coopérative",
    info3:
      "Si votre ferme fait partie d'une coopérative, veuillez fournir les informations sur la coopérative.",
    cooperativeLogo: "Logo de la coopérative",
    traceabilityIntro: "Introduction à la traçabilité",
    info4:
      "Fournissez plus d'informations sur le suivi et la traçabilité de votre produit tout au long de sa chaîne d'approvisionnement, de la production ou de l'origine jusqu'au consommateur final.",
    addLabel: "Ajouter une étiquette",
    chooseTitle: "Choisir un titre",
    chooseLabelDesign: "Choisir un modèle de conception d'étiquette",
    uploadYourLogo: "Télécharger votre logo",
    info5:
      "Instructions : La taille de l'image doit être d'au moins 1000 x 1000 pixels carrés. Vous pouvez choisir un PNG transparent pour qu'il s'adapte aux couleurs de fond.",
    chooseTemplateColors: "Choisir les couleurs du modèle",
    backgroundColor: "Couleur de fond",
    foregroundColor: "Couleur de premier plan",
    labelStatus: "Statut de l'étiquette",
    inactive: "Inactif",
    download: "Télécharger",
    enterLabelTitle: "Entrez le titre de l'étiquette",
    enableLogoProcessing: "Activer le traitement du logo",
  },
  cacaoTraceability: {
    traceability: "traçabilité",
    cacaoTraceabilityMngmnt: "Gestion de la traçabilité du cacao",
    traceabilityPage: "Page de traçabilité",
    labelDesigner: "Concepteur d'étiquettes",
    additionalInformation: "Informations supplémentaires",
    info1:
      "Fournissez des informations sur les logos supplémentaires de votre produit. Ces informations seront disponibles au public sur la page de traçabilité du cacao.",
    addSlogan: "Ajouter un slogan",
    additionalLogos: "Logos supplémentaires",
    title: "Titre",
    description: "Description",
    mapLink: "Lien vers la carte",
    websiteLink: "Lien du site Web",
    addMedia: "Ajouter des médias",
    uploadImageVideo: "Télécharger une image/vidéo",
    origin: "Origine",
    info2:
      "Fournissez des informations sur le pays d'origine de votre produit. Ces informations seront disponibles au public sur la page de traçabilité du cacao.",
    countryImage: "Image du pays",
    institutionalInfo: "Informations institutionnelles",
    info3:
      "Fournissez des informations sur votre entreprise/coopérative, parlez aux consommateurs des travaux pertinents que vous avez effectués. Ces informations seront disponibles au public sur la page de traçabilité du cacao.",
    cooperativeLogo: "Logo de la coopérative",
    traceabilityIntro: "Introduction à la traçabilité",
    info4:
      "Cette section donnera au consommateur un accès à l'intégralité de l'historique de la production et du traitement du café. Décrivez l'importance de la traçabilité pour votre entreprise/coopérative et pour le monde.",
    addLabel: "Ajouter une étiquette",
    chooseTitle: "Choisir un titre",
    chooseLabelDesign: "Choisir un modèle de conception d'étiquette",
    uploadYourLogo: "Télécharger votre logo",
    info5:
      "Instructions : La taille de l'image doit être d'au moins 1000 x 1000 pixels carrés. Vous pouvez choisir un PNG transparent pour qu'il s'adapte aux couleurs de fond.",
    chooseTemplateColors: "Choisir les couleurs du modèle",
    backgroundColor: "Couleur de fond",
    foregroundColor: "Couleur de premier plan",
    labelStatus: "Statut de l'étiquette",
    inactive: "Inactif",
    download: "Télécharger",
    enterLabelTitle: "Entrez le titre de l'étiquette",
    
    originTitle: "Titre de l'origine",
    corporativeTile: "Titre de la coopérative",
    enterSlogan: "Entrez le slogan",
    enterTitle: "Entrez le titre",
    enterDescription: "Entrez la description",
    enterMapLink: "Entrez le lien de la carte",
    enterWebsiteLink: "Entrez le lien du site Web",
  },
}
